import { Dialog, Typography } from "@material-ui/core"
import { FormNuevaSolicitud } from "./FormNuevaSolicitud"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { LimpiarEmpresComunicacion, limpiarDatosSuspensionEmpresa } from "../../actions/comunicacionConEmpresas/comunicacionConEmpresas"

export const NuevaSolicitud = (props) => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(limpiarDatosSuspensionEmpresa());
        dispatch(LimpiarEmpresComunicacion());
    }, [dispatch])

    return (
        <Dialog
            fullWidth
            maxWidth={"md"}
            open={props.open}>
            <Typography variant="h6" style={{ marginTop: '1rem', textAlign: 'center' }}>Nueva Solicitud</Typography>
            <FormNuevaSolicitud cerrarModal={props.onClose} />
        </Dialog>
    )
}